// отделяем необходимые пропсы для передачи в компонент
var getListModalMobileProps = function (props) {
    var ModalMobile = props.ModalMobile, dataTestId = props.dataTestId, modalProps = props.modalProps, modalHeaderProps = props.modalHeaderProps, modalFooterProps = props.modalFooterProps, label = props.label, placeholder = props.placeholder, _a = props.isBottomSheet, isBottomSheet = _a === void 0 ? true : _a, _b = props.nativeSelect, nativeSelect = _b === void 0 ? false : _b, onScroll = props.onScroll;
    return {
        ModalMobile: ModalMobile,
        dataTestId: dataTestId,
        modalProps: modalProps,
        modalHeaderProps: modalHeaderProps,
        modalFooterProps: modalFooterProps,
        label: label,
        placeholder: placeholder,
        isBottomSheet: isBottomSheet,
        nativeSelect: nativeSelect,
        onScroll: onScroll,
    };
};

export { getListModalMobileProps };
